import React from 'react';

const ExpireIcon = () => (
    <svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.75 18L6.59375 14.5L1.4375 18V7.9375C1.4375 7.5894 1.58566 7.25556 1.84938 7.00942C2.1131 6.76328 2.47079 6.625 2.84375 6.625H10.3438C10.7167 6.625 11.0744 6.76328 11.3381 7.00942C11.6018 7.25556 11.75 7.5894 11.75 7.9375V18Z" stroke="#62646A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M5.65625 4H13.1562C13.5292 4 13.8869 4.13828 14.1506 4.38442C14.4143 4.63056 14.5625 4.9644 14.5625 5.3125V14.9375" stroke="#62646A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

export default ExpireIcon;
